/* unplugin-vue-components disabled */import script from "./CourseDesignList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseDesignList.vue?vue&type=script&setup=true&lang=ts"

import "./CourseDesignList.vue?vue&type=style&index=0&id=1251c84e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1251c84e"]])

export default __exports__